import Section from "../common/Section.tsx";
import { useIntl } from "react-intl";
import BookshelfReadAloud from "../../../../common/icons/BookshelfReadAloud.tsx";
import EditHighlighter from "../../../../common/icons/EditHighlighter.tsx";
import BookshelfAa from "../../../../common/icons/BookshelfAa.tsx";
import styles from "./ReaderTips.module.scss";
import { useBrandLoaderData } from "../../../root/rootLoader.ts";
import usePromoConfig from "../common/usePromoConfig.ts";
import NamedPromo from "../common/NamedPromo.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";

export default function ReaderTips() {
  const intl = useIntl();
  const brand = useBrandLoaderData();
  const { secondaryItem } = usePromoConfig();

  const studyFeatures = [
    brand.Highlights.Notes.enabled &&
      intl.formatMessage({ defaultMessage: "notes" }),
    brand.Highlights.enabled &&
      intl.formatMessage({ defaultMessage: "highlights" }),
    brand.Bookmarks.enabled &&
      intl.formatMessage({ defaultMessage: "bookmarks" }),
  ].filter((el) => !!el);

  const cards = [
    {
      title: intl.formatMessage({
        defaultMessage: "Learn while you listen",
      }),
      description: intl.formatMessage({
        defaultMessage:
          "Listen to your book on the go with our Read Aloud feature.",
      }),
      icon: <BookshelfReadAloud />,
      href: brand.Support.readAloudUrl,
      enabled: brand.ReadAloud.enabled,
    },
    {
      title: intl.formatMessage({ defaultMessage: "Study your way" }),
      description: intl.formatMessage(
        {
          defaultMessage: "Customize your experience with {featureList}.",
        },
        {
          featureList: intl.formatList(studyFeatures, { type: "conjunction" }),
        }
      ),
      icon: <EditHighlighter />,
      href: brand.Support.marginNotesUrl,
      enabled: studyFeatures.length > 0,
    },
    {
      title: intl.formatMessage({
        defaultMessage: "Customize your reader experience",
      }),
      description: intl.formatMessage({
        defaultMessage:
          "Customize your font size, display colors, reading view, and more.",
      }),
      icon: <BookshelfAa />,
      href: brand.Support.readerPreferencesUrl,
      enabled: true,
    },
  ].filter((el) => el.enabled);

  if (cards.length === 0) {
    return null;
  }

  const titles = {
    ["Read & Study"]: intl.formatMessage({ defaultMessage: "Read & Study" }),
    ["Reader Features"]: intl.formatMessage({
      defaultMessage: "Reader Features",
    }),
  };

  return (
    <Section
      gridClassName={styles.grid}
      title={titles[brand.DashboardReaderFeatures.headerText]}
      subtitle={intl.formatMessage({
        defaultMessage: "Learn how to use your reader to its full potential.",
      })}
    >
      <div className={styles.cards}>
        {cards.map((card) => (
          <BaseLinkOrButton
            key={card.title}
            className={styles.card}
            href={card.href}
          >
            <div className={styles.iconHolder}>{card.icon}</div>
            <div>
              <h3 className={styles.title}>{card.title}</h3>
              <div className={styles.description}>{card.description}</div>
            </div>
          </BaseLinkOrButton>
        ))}
      </div>
      {secondaryItem && (
        <NamedPromo name={secondaryItem} className={styles.rightPromo} />
      )}
    </Section>
  );
}
